/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Ownershipverificationdescription3Inputs */

const id_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`didasarkan pada penyelesaian setidaknya satu pencapaian oleh pemain.`)
};

const ms_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adalah berdasarkan penyempurnaan sekurang-kurangnya satu pencapaian oleh pemain.`)
};

const da_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`er baseret på gennemførelse af mindst én achievement af spilleren.`)
};

const de_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`basiert auf dem Abschluss mindestens einer Errungenschaft durch den Spieler.`)
};

const en_us2_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is based on the completion of at least one achievement by the player.`)
};

const es_es2_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`se basa en la compleción de al menos un logro por el jugador.`)
};

const es_mx2_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`se basa en la finalización de al menos un logro por el jugador.`)
};

const fil_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ay batay sa pagkumpleto ng kahit isang achievement ng manlalaro.`)
};

const fr_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`est basée sur l'obtention d'au moins un succès par le joueur.`)
};

const it_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`si basa sul completamento di almeno un risultato da parte del giocatore.`)
};

const hu_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a játékos által elért legalább egy teljesítmény teljesítésén alapul.`)
};

const nl_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is gebaseerd op het voltooien van ten minste één prestatie door de speler.`)
};

const no_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`er basert på fullføring av minst én prestasjon av spilleren.`)
};

const pl_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opiera się na ukończeniu co najmniej jednego osiągnięcia przez gracza.`)
};

const pt_br2_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`é baseado na conclusão de pelo menos uma conquista pelo jogador.`)
};

const pt_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`baseia-se na conclusão de pelo menos uma conquista pelo jogador.`)
};

const ro_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`se bazează pe finalizarea a cel puțin unei realizări de către jucător.`)
};

const fi_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`perustuu vähintään yhden saavutuksen suorittamiseen pelaajan toimesta.`)
};

const sv_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`baseras på att spelaren har slutfört minst en prestation.`)
};

const vi_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dựa trên việc hoàn thành ít nhất một thành tích của người chơi.`)
};

const tr_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oyuncunun en az bir başarımı tamamlamasına dayanır.`)
};

const cs_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`je založeno na dokončení alespoň jednoho úspěchu hráčem.`)
};

const bg_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`се основава на завършването на поне едно постижение от играча.`)
};

const ru_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`основывается на выполнении игроком хотя бы одного достижения.`)
};

const uk_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`базується на виконанні гравцем хоча б одного досягнення.`)
};

const ar_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يعتمد على إكمال اللاعب إنجازًا واحدًا على الأقل.`)
};

const hi_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खिलाड़ी द्वारा कम से कम एक उपलब्धि पूरी करने पर आधारित है।`)
};

const th_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ขึ้นอยู่กับการสำเร็จความสำเร็จอย่างน้อยหนึ่งรายการโดยผู้เล่น`)
};

const ja_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレイヤーが少なくとも1つの実績を達成することに基づきます。`)
};

const zh_cn2_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于玩家是否至少完成了一个成就。`)
};

const zh_hant1_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基於玩家是否至少完成了一個成就。`)
};

const ko_offerdetail_reviews_ownershipverificationdescription3 = /** @type {(inputs: Offerdetail_Reviews_Ownershipverificationdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플레이어가 최소 하나의 도전 과제를 완료한 것을 기준으로 합니다.`)
};

/**
* | output |
* | --- |
* | "is based on the completion of at least one achievement by the player." |
*
* @param {Offerdetail_Reviews_Ownershipverificationdescription3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_ownershipverificationdescription3 = /** @type {((inputs?: Offerdetail_Reviews_Ownershipverificationdescription3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Ownershipverificationdescription3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "da") return da_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "de") return de_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "it") return it_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "no") return no_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "th") return th_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_ownershipverificationdescription3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_ownershipverificationdescription3(inputs)
	return ko_offerdetail_reviews_ownershipverificationdescription3(inputs)
});
export { offerdetail_reviews_ownershipverificationdescription3 as "offerDetail.reviews.ownershipVerificationDescription" }